'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function PMFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-qpn7e0sah", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-qpn7e0sah)" }, /* @__PURE__ */ React.createElement("path", { fill: "#c51918", d: "M22 0h10v24H22z" }), /* @__PURE__ */ React.createElement("path", { fill: "#2e42a5", d: "M0 0h12v24H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M10 0h12v24H10z" })))
  );
}

export { PMFlag };
//# sourceMappingURL=PM.mjs.map
